import PropTypes from 'prop-types';
import React, { useState } from 'react';

import Button from '../Button/Button';
import Spinner from '../Spinner/Spinner';

const ButtonWithLoadingIndicator = ({
  children,
  disabled,
  onClick = () => {},
  onLoadComplete = () => {},
  ...props
}) => {
  const [isLoading, setLoading] = useState(null);
  return (
    <Button
      className="branded-button"
      disabled={isLoading || disabled}
      onClick={async () => {
        setLoading(true);
        await onClick();
        setLoading(false);
        onLoadComplete();
      }}
      {...props}
    >
      <Spinner showSpinner={isLoading}>{children}</Spinner>
    </Button>
  );
};

ButtonWithLoadingIndicator.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  onLoadComplete: PropTypes.func
};

export default ButtonWithLoadingIndicator;
